"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toaster = exports.AnimatedToasters = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
class Toaster extends _react.Component {
  handleCloseToaster() {
    if (this.props.closeToast) {
      this.props.closeToast();
    }
  }
  render() {
    const props = this.props;
    const {
      header,
      message,
      className
    } = props.toasterData ? props.toasterData : {
      header: null,
      message: null,
      className: null
    };
    const divStyle = header && message && className ? {
      position: 'fixed',
      top: 15,
      right: 15,
      width: '400px',
      zIndex: 9999,
      transition: 'opacity 1s',
      opacity: props.opacity
    } : {};
    return /*#__PURE__*/_react.default.createElement("div", {
      style: divStyle,
      className: className
    }, /*#__PURE__*/_react.default.createElement("h4", {
      className: "alert-heading"
    }, header), /*#__PURE__*/_react.default.createElement("div", null, message), /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "btn-close",
      "aria-label": "Close",
      onClick: this.handleCloseToaster.bind(this)
    }));
  }
}
exports.Toaster = Toaster;
class AnimatedToasters extends _react.Component {
  constructor(props) {
    super(props);
    this.autoClose = props.autoClose ?? true;
    this.autoCloseDelay = props.autoCloseDelay ?? this.autoClose ? 5000 : 0;
    this.state = {
      toasterData: props.toasterData
    };
  }
  componentDidUpdate() {
    this.state.toasterData = this.props.toasterData;
  }
  handleCloseToast(id) {
    const newToasterData = this.state.toasterData.filter(td => td.id !== id);
    this.setState({
      toasterData: newToasterData
    });
  }
  render() {
    const state = this.state;
    return state.toasterData && /*#__PURE__*/_react.default.createElement(Animate, {
      key: state.toasterData.id,
      autoCloseDelay: this.autoCloseDelay,
      toasterData: state.toasterData,
      closeToast: this.handleCloseToast.bind(this)
    });
  }
}
exports.AnimatedToasters = AnimatedToasters;
class Animate extends _react.Component {
  state = {
    closed: false,
    opacity: 0
  };
  autoCloseTimer = null;
  componentDidMount() {
    this.startTimer();
  }
  componentDidUpdate() {
    if (this.props.toasterData && this.props.toasterData.closed !== undefined && !this.props.toasterData.closed) {
      clearTimeout(this.autoCloseTimer);
      this.startTimer();
    }
  }
  startTimer() {
    this.setState({
      opacity: 1
    });
    if (this.props.autoCloseDelay > 0) {
      this.autoCloseTimer = setTimeout(() => {
        this.close();
      }, this.props.autoCloseDelay);
    }
  }
  handleInnerToasterClose() {
    clearTimeout(this.autoCloseTimer);
    this.close();
  }
  close() {
    this.setState({
      closed: true,
      opacity: 0
    });
  }
  handleFadeOutDone(id) {
    if (this.props.closeToast) {
      this.props.closeToast(id);
    }
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(Toaster, {
      opacity: this.state.opacity,
      toasterData: this.props.toasterData,
      closeToast: this.handleInnerToasterClose.bind(this)
    });
  }
}